import { withFeatureVisibility } from "../../../HoC";
import { NavigationButtonProps } from "../../../types";
import { NavigationBarButtonWithSubroutes, NavigationBarButtonWithoutSubroutes } from "./variants";

export const NavigationBarButton = ({ route, shopId, onClick }: NavigationButtonProps) => {
  const { subroutes, translationKey, path, requiredPermission, featureFlag } = route;

  if (subroutes) {
    if (featureFlag) {
      const Component = withFeatureVisibility(NavigationBarButtonWithSubroutes, featureFlag);

      return (
        <Component
          translationKey={translationKey}
          path={path}
          shopId={shopId}
          onClick={onClick}
          subroutes={subroutes}
          requiredPermission={requiredPermission}
        />
      );
    } else {
      return (
        <NavigationBarButtonWithSubroutes
          translationKey={translationKey}
          path={path}
          shopId={shopId}
          onClick={onClick}
          subroutes={subroutes}
          requiredPermission={requiredPermission}
        />
      );
    }
  }

  if (path) {
    if (featureFlag) {
      const Component = withFeatureVisibility(NavigationBarButtonWithoutSubroutes, featureFlag);

      return (
        <Component
          translationKey={translationKey}
          path={path}
          shopId={shopId}
          onClick={onClick}
          requiredPermission={requiredPermission}
        />
      );
    } else {
      return (
        <NavigationBarButtonWithoutSubroutes
          translationKey={translationKey}
          path={path}
          shopId={shopId}
          onClick={onClick}
          requiredPermission={requiredPermission}
        />
      );
    }
  }

  return null;
};
